import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import { NAVBAR_SPACE } from '../Navbar/Navbar';

export default function Description({ appPageData }) {
    if (!appPageData) return <></>;
    return (
        <Container maxWidth='lg' sx={{ my: { xs: '60px', sm: '60px', md: '80px' }, px: NAVBAR_SPACE }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                <Typography sx={{ mb: '12px' }} variant='blue'>{appPageData.dSmall}</Typography>
                <Typography sx={{ mb: '18px' }} variant='big'>{appPageData.dTitle}</Typography>
                <Typography>{appPageData.dText}</Typography>
            </Box>
        </Container>
    )
}
